import React from "react";
import "./AboutUs.css";
import AboutImg from "../../../Assets/images/soon.png";
import TransHook from "../../../hook/locale/trans-hook";

const AboutUS = () => {
  const [, , t] = TransHook();
  return (
    <div className="container">
      <div className="aboutUs">
        <div className="AboutUs-img">
          <img src={AboutImg} alt="" />
        </div>
        <div className="AboutUs-Text">
          <h2 className="text-uppercase">{t("aboutUs")}</h2>
          <p style={{ fontSize: "14px", fontWeight: "400" }}>
            SOON KITCHEN GIDA ANONİM ŞİRKETİ’NDEN OLAĞAN GENEL KURUL
            TOPLANTISINA ÇAĞRI Şirketimizin 2022-2023-2024 yılına ait Olağan
            Genel Kurul Toplantısı, aşağıda yazılı gündem maddelerini görüşmek
            ve karara bağlamak üzere, 28 Ağustos 2025 Perşembe günü saat
            11:30'da, Mahmutbey Mahallesi Hacı Bostan Caddesi No:22/11 Bağcılar
            / İstanbul adresinde yapılacaktır. Toplantıya bizzat katılamayacak
            ortaklarımızın, vekaletnamelerini usulüne uygun olarak düzenlemeleri
            ve imzalamaları, noterden tasdik ettirmeleri vekaletnamelerini
            toplantı öncesinde Şirketimize teslim etmeleri gerekmektedir. Sayın
            ortaklarımızın belirtilen gün ve saatte toplantıda hazır bulunmaları
            rica olunur. GÜNDEM :
          </p>
          <ul style={{ fontSize: "14px", fontWeight: "400" }}>
            <li>Açılış ve başkanlık divanının seçimi</li>
            <li>
              Toplantı tutanağının imzalanması için divana yetki verilmesi
            </li>
            <li>
              ⁠Yönetim kurulunca hazırlanan yıllık faaliyet raporlarının
              okunması ve müzakeresi
            </li>
            <li>Finansal tabloların okunması, müzakeresi ve tasdiki</li>
            <li>Yönetim kurulu üyelerinin ibrası</li>
            <li>Yönetim kurulu üyelerinin yeniden seçimi</li>
            <li>Yönetim kurulu üyelerine ödenecek ücretlerin tespiti</li>
            <li> ⁠Dilek ve temenniler, kapanış</li>
          </ul>
          <p>
            Saygılarımızla,
            <br /> SOON KITCHEN GIDA ANONİM ŞİRKETİ <br />
            Yönetim Kurulu
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUS;
